/** @format */

import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import useQuery from '../queryString';

/** @format */
const Pagination = ({ totalPage, basePath }) => {
	const navigate = useNavigate();
	const pageParam = useQuery.getParam('page');
	const pageCount = Math.max(0, Number(totalPage) || 0);

	if (pageCount <= 1) {
		return null;
	}

	return (
		<div className='w-100 mt-4 d-flex'>
			{/*<Pagination meta={eventContext.users.meta} />*/}
			<ReactPaginate
				breakLabel='...'
				nextLabel='بعدی'
				pageRangeDisplayed={5}
				pageCount={pageCount}
				previousLabel='قبلی'
				initialPage={pageParam === null ? 0 : parseInt(pageParam) - 1}
				pageClassName='c-pointer'
				pageLinkClassName='page-link'
				activeLinkClassName='active-page'
				previousLinkClassName='page-link'
				nextLinkClassName='page-link'
				disabledLinkClassName='disable-page'
				onClick={(page) => {
					return navigate(
						page.event.target.href.replace(window.location.origin, ''),
					);
				}}
				hrefBuilder={(page, pageCount, selected) =>
					page >= 1 && page <= pageCount ? `${basePath}${basePath.indexOf('?') === -1 ? '?' : '&'}page=${page}` : '#'
				}
				containerClassName='d-flex flex-row align-items-center list-style-none justify-content-center w-100'
				renderOnZeroPageCount={null}
			/>
		</div>
	);
};

export default Pagination;
